<template>
    <div ref="fred" class="greybox" v-if="bookingDates.length != 0">
        <h1>Select a date for the repair...</h1>
        <div v-for="(bookingDates, index) in bookingDatesGrouped" :key="'bd_' + index" class="row">
            <div v-for="(bookingDate, index) in bookingDates" :key="index + '-' + index" class="col-md-4 align-self-center" align="center">
                <div :class="getCardClass(selectedBookingDate, bookingDate)" :style="'width: 10rem; height: 10rem;'" @click="setSelectedBookingDate(bookingDate)">

                    <h5
                        :class="'card-title mt-4'">
                        {{bookingDate.full_date}}
                    </h5>
                    <span class="lead" style="color: green;">AVAILABLE</span>
                    <!-- <button class="button-small" @click="setSelectedBookingDate(bookingDate)"><strong>Select</strong></button> -->
                </div>
            </div>
        </div>
        <div v-if="!isSelectedDateValid && nextAttempt" class="mt-5 text-danger">
            <small>Please select a date for the repair</small>
        </div>
        <div ref="bottom">
            <div v-if="requireCardDetailsAndPayment">
                <h3 class="mt-5 mb-5">You will also need to pay the applicable excess amount...</h3>
                <div style="text-align:center;">
                <div class="mb-5" style="display: inline-block; border: 3px solid #ccc; background-color: white; width: 200px; padding: 20px 10px 5px 10px; box-sizing: border-box;">
                    <p style="font-size:large; font-weight: bold; text-align: center">Total excess: &pound;{{totalExcess}}</p>
                </div>
                </div>
                <card-details v-model="excessCardDetails" ref="cardDetails" @isValid="handlepaymentDetailsIsValid" />
            </div>

            <transition name="fade">
                <div
                    v-if="hasErrors"
                    class="text-danger mt-5 mb-5">
                    <i class="fas fa-exclamation-triangle mr-2"></i><strong>There seems to be a problem please try again.</strong>
                </div>
            </transition>
            <div class="button-fluid-container">
                <button class="button" @click="handleBackClick()">Back</button>
                <button class="button" @click="setDate()">Continue</button>
            </div>
            
        </div>
        <loading :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </div>
</template>
<script>
import repairOptionsBase from '@/mixins/repairOptionsBase'
import cardDetails from '@/components/CardDetails.vue'
import loading from 'vue-loading-overlay'
// import backtoTop from '@/components/taurus-backtotop/components/BacktoTop.vue'

import { smoothScrollTo } from '@/util/smoothScroll.js'

import axios from 'axios'

let baseUrl = process.env.VUE_APP_API_BASE_URL

const chunk = (arr, chunkSize, cache = []) => {
  const tmp = [...arr]
  while (tmp.length) cache.push(tmp.splice(0, chunkSize))
  return cache
}

let required = (value) => {
  return !(value === undefined || value === null || value === '')
}

export default {
    name: 'repairoptionsbookingdte',
    components: {
        cardDetails,
        loading
    },
    mixins: [
        repairOptionsBase
    ],
    data: () => {
        return {
            selectedBookingDate: null,
            nextAttempt: false,
            addDeviceMessage: null,
            cardDetailsValid: false,
        }
    },
    beforeMount () {
        this.populateCardDetailsFromClaimant()
    },
    computed: {
        bookingDatesGrouped () {
            let availableDates = this.bookingDates.filter(d => d.available == true)

            return chunk(availableDates, 3)
        },
        requireCardDetails () {
            return this.selectedRepairOption.repairOptionWebDisplayRequireCardDetails
        },
        requirePayment () {
            return !this.selectedGadget.excessCardPayment
        },
        requireCardDetailsAndPayment () {
            if (this.requireCardDetails) {
                return this.requirePayment
            }
            return false
        },
        isSelectedDateValid () {
            return required(this.selectedBookingDate)
        },
        isFormValid () {
            if (this.requireCardDetailsAndPayment) {
                return this.cardDetailsValid && this.isSelectedDateValid
            }
            return this.isSelectedDateValid
        }
    },
    methods: {
        scrollTo(ref) {
            smoothScrollTo(window, this.$refs[ref], 0, 500)
        },
        getCardClass (selectedItem, item) {
            if (selectedItem) {
                return selectedItem == item ? 'my-card-selected my-card' : 'my-card'
            }

            return 'my-card'
        },
        setSelectedBookingDate (date) {
            this.selectedBookingDate = date
            this.scrollTo('bottom')
        },
        handlepaymentDetailsIsValid (value) {
           this.cardDetailsValid = value
        },
        handleBackClick () {
            this.$router.push({path: '/myclaims/repairoptions/bookingmod/'})
        },
        setDate () {
            this.nextAttempt = true

            if (this.requireCardDetailsAndPayment) {
                this.$refs.cardDetails.triggerValidation()
            }

            if (this.isFormValid) {
                this.isLoading = true

                if (this.requirePayment) {
                    this.payExcessSetRepairOptionMakeBooking(this.selectedGadgetId)
                } else {
                    this.setRepairOptionMakeBooking(this.selectedGadgetId)
                }
            }
        },
    }
}
</script>

